import type { BaseError } from '@takeshape/errors';
import { type ErrorAction, insufficientPermissions, missingEntitlement, unauthorizedRequest } from '../actions.js';

export default function handleError(error: BaseError): ErrorAction | null {
  if (error.code === 'UnauthorizedError') {
    return unauthorizedRequest();
  }

  if (error.code === 'ForbiddenError') {
    return insufficientPermissions();
  }

  if (error.code === 'EntitlementError') {
    return missingEntitlement(error);
  }

  return null;
}

export function getSavingErrorMessage(verb: string, type: string): ({ payload }: { payload: string }) => string {
  return ({ payload }: { payload: string }): string => {
    const errorMessage = payload.replace('GraphQL Error:', '');
    return `${verb} ${type} failed: ${errorMessage}`;
  };
}
